import { configureSafeSend } from "@umami/safesend";
import { getEnv } from "@umami/utils";

configureSafeSend({
  mainnet: {
    native: {
      type: "contract",
      pkh: getEnv("VITE_SAFE_SEND_NATIVE_CONTRACT_MAINNET") || "",
    },
    fa12: {
      type: "contract",
      pkh: getEnv("VITE_SAFE_SEND_FA12_CONTRACT_MAINNET") || "",
    },
    fa2: {
      type: "contract",
      pkh: getEnv("VITE_SAFE_SEND_FA2_CONTRACT_MAINNET") || "",
    },
  },
  shadownet: {
    native: {
      type: "contract",
      pkh: getEnv("VITE_SAFE_SEND_NATIVE_CONTRACT_SHADOWNET") || "",
    },
    fa12: {
      type: "contract",
      pkh: getEnv("VITE_SAFE_SEND_FA12_CONTRACT_SHADOWNET") || "",
    },
    fa2: {
      type: "contract",
      pkh: getEnv("VITE_SAFE_SEND_FA2_CONTRACT_SHADOWNET") || "",
    },
  },
});
